import React from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import LHModalPop from '../../../components/LHModalPop';
import { RootState } from '../../../store';
import { hideErrorModal, removeErrorById } from '../../../store/slices/employeeUpdatesSlice';

const getApiTitle = (apiName?: string): string => {
  if (!apiName) return 'Error';
  const words = apiName
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
  return `${words} Failed`;
};

const EmployeeUpdateErrorModal: React.FC = () => {
  const dispatch = useDispatch();
  const centralized = useSelector((state: RootState) => (state as any).employeeUpdates?.centralizedErrors || { activeError: null, isErrorModalVisible: false });
  const { activeError, isErrorModalVisible } = centralized;

  const handleClose = () => {
    try {
      if (activeError) {
        dispatch(removeErrorById(activeError.id));
      }
    } catch (e) {
      // swallow
      // eslint-disable-next-line no-console
      console.warn('Failed to remove centralized employee update error:', e);
    }
    try {
      dispatch(hideErrorModal());
    } catch (e) {
      // swallow
      // eslint-disable-next-line no-console
      console.warn('Failed to hide centralized employee update modal:', e);
    }
  };

  if (!activeError) return null;

  return (
    <LHModalPop
      visible={isErrorModalVisible}
      onClose={handleClose}
      title={getApiTitle(activeError.apiName)}
      // use description prop so modal styling matches other modules
      description={activeError.message}
      showFooter={true}
      primaryButtonText="OK"
      secondaryButtonText=""
      onPrimaryPress={handleClose}
      showCloseButton={true}
    />
  );
};

const styles = StyleSheet.create({
  // keep styles minimal – description styling is handled by LHModalPop
  modalDetails: {
    fontSize: 14,
    color: '#6B6B6B',
    lineHeight: 20,
    textAlign: 'left',
    marginTop: 8,
    fontFamily: Platform.select({
      ios: 'Inter',
      android: 'Inter-Regular',
      web: 'Inter, -apple-system, Roboto, Helvetica, sans-serif',
    }),
  },
});

export default EmployeeUpdateErrorModal;
